<template>
	<div id="app">
		<el-container class=" indexMain">
			<el-header>
				<nav-header></nav-header>
			</el-header>
			<el-main>
				<router-view />
			</el-main>
			<el-footer>
				<footer-app></footer-app>
			</el-footer>
		</el-container>
		<!-- <div class="indexbg relative"  v-show="showAnimate" @click="goIndex()">
           <div class="index-title clearfix">
               <img src="static/images/index-title.png" alt="" class="pull-left">
               <div class="pull-right ">
                   <img class="inline-block tel" src="static/images/index-tel.png" />
       
                   <img class="inline-block email" src="static/images/index_email.png" />
               </div>
           </div>
           
            <img src="static/images/title-name.png" alt="" class="title-name absolute " >
            <img src="static/images/title-nameE.png" alt="" class="title-nameE absolute " >
            <div class="index-footer text-center relative">
                <div class="color-white">点击任意位置进入官网</div>
                <img src="static/images/index-footer.png" alt="" class="footer-loca">
                滑动效果遮罩层
                <div class="absolute movingOuter">
                  <div class="absolute movingInner"></div>
                </div>
                
            </div>
            v-show="!showAnimate"
       </div> -->




	</div>
</template>

<script>
	// import navHeader from '@/components/common/navHeader.vue';
	import navHeader from './components/navHeader/index';
	import footerApp from '@/components/common/footerApp.vue';
	import bus from '@/assets/js/bus'
	export default {
		name: 'App',
		data() {
			return {
				showAnimate: true
			}
		},
		methods: {
			goIndex() {
				/*$('.indexbg').remove();
				$('.indexMain').removeClass('hide');*/
				this.showAnimate = false;
			},

		},
		components: {
			"nav-header": navHeader,
			"footer-app": footerApp
		},
		created() {
			//刷新时才会触发
			//console.log(this.$route)
			//console.log(this.$router.history)
			bus.$on('NoshowAnimate', (boolean) => {
				this.showAnimate = boolean;
			})
		},
		mounted: function() {
			this.$nextTick(function() {
				// Code that will run only after the
				// entire view has been rendered
			})
		},
	}
</script>

<style>
	/* 公共样式 */
	@import "./assets/css/public.css";

	/* 字体样式 */
	/* @import "./assets/css/font-awesome/font-awesome.min.css"; */
	.indexbg {
		/* background: url(../static/images/index-bg.png) no-repeat center center; */
		height: 960px;
	}

	.index-title {
		width: 1204px;
		padding-top: 40px;
		margin: 0 auto;
		color: #eaebed;
	}

	.index-title img {
		width: 90px;
		height: 62px;
	}

	.index-title .tel {
		padding-right: 42px;
		margin-top: 24px;
		width: 132px;
		height: 14px;
		border-right: 3px solid #eaebed;
	}

	.index-title .email {
		margin-top: 22px;
		padding-left: 38px;
		width: 192px;
		height: 16px;
	}

	.title-name {
		display: block;
		width: 1202px;
		margin: 266px auto 0;
		height: 110px;
		left: 50%;
		margin-left: -601px;
		animation: 1s slidedown;
		animation-fill-mode: forwards;
	}

	.title-nameE {
		display: block;
		width: 1204px;
		margin: 0 auto;
		height: 26px;
		left: 50%;
		margin-left: -602px;
		animation: 1s slideimg;
		animation-delay: 1s;
		animation-fill-mode: forwards;
		bottom: -20px;
	}

	.index-footer {
		margin: 680px auto 0;
		font-size: 14px;
		overflow-x: hidden;
		width: 142px;
	}

	.index-footer .footer-loca {
		margin-top: 12px;
	}

	/* 扫过动画 */
	.movingOuter {
		width: 100%;
		height: 20px;
		top: 0;
		left: 5px;
		background: #161d22;
		opacity: 0.4;
		animation: moving 2s infinite;
		animation-fill-mode: forwards;
		border-radius: 25px;
	}

	@keyframes moving {
		0% {
			top: 0;
			left: 5px;
		}

		100% {
			top: 0;
			left: 316px;
		}
	}

	.movingInner {
		width: 820px;
		height: 100%;
		top: 0;
		left: -874px;
		background: #161d22;
		border-radius: 25px;
	}

	/* 公司名称动画 */
	@keyframes slidedown {
		0% {
			margin-top: 0px;
		}

		100% {
			margin-top: 266px;
		}
	}

	@keyframes slideimg {
		0% {
			bottom: 0;
		}

		100% {
			bottom: 427px;
		}
	}

	/* 点击进入首页 */
	.indexMain {
		/*  width:1920px; */
		margin: 0 auto;
		min-width: 970px;
	}
	.indexMain .el-header{
		padding: 0;
	}
	.indexMain .el-main{
		padding: 0;
	}
	.indexMain .el-footer{
		padding: 0;
	}
	

	.indexLine {}
</style>



// WEBPACK FOOTER //
// src/App.vue